/**
 * Wishlist Collage Panel
 *
 * Dear developer, if you are reading this, I'm terribly sorry
 */

import PropTypes from 'prop-types';
import EventList from './EventList';
import DeletePanel from './DeletePanel';
import CollageContainer from './CollageContainer';
import WeddingCircleInPre from '../WeddingCircleInPre';
import ErrorMsg from '../ErrorMsg';
import GoFetch from '~/js/modules/fetchling';
import Modal from '~/js/components/global/Modal';
import LoginPanel from '~/js/components/wedding-styler/dashboard/LoginPanel';

const internals = {};

const { Fragment } = React;

internals.padNum = (n) => n < 10 ? '0' + n : n;

export default class WishlistCollagePanel extends React.Component {
  static propTypes = {
    wishlistInfo: PropTypes.object,
    wishlistDetailData: PropTypes.object,
    wishlistUser: PropTypes.object,
    wishlistRegion: PropTypes.object,
    ceremonyCollageData: PropTypes.array,
    receptionCollageData: PropTypes.array,
    countries: PropTypes.array,
    calculateWishlistTotal: PropTypes.func
  };

  static defaultProps = {
    wishlistInfo: {},
    wishlistDetailData: {},
    wishlistUser: {},
    wishlistRegion: {},
    ceremonyCollageData: [],
    receptionCollageData: [],
    countries: []
  };

  constructor(props) {
    super(props);

    const { wishlistRegion } = this.props;

    this.state = {
      displayCeremonyCollage: true,
      showDeletePanel: false,
      showErrorMsg: false,
      wishlistLastDateSaved: null,
      wishlistItems: null,
      wishlistItemCount: null,
      wishlistTotal: null,
      wishlistDeleted: false,
      wishlistCount: null,
      ceremonyCollageData: [],
      receptionCollageData: [],
      emailSent: null,
      wasDataSaved: null,
      isDashboardOpen: false,
      isInclusionsOpen: false,
      userWishlists: [],
      wishlistRegion
    };
  }

  componentWillMount() {
    if (!Object.keys(this.props.wishlistInfo).length || !Object.keys(this.props.wishlistUser).length || !this.props.wishlistInfo.lastUpdate) {
      this.setState({ showErrorMsg: true });

      return;
    }

    const { monthValue, dayOfMonth, year, hour, minute } = this.props.wishlistInfo.lastUpdate;
    const wishlistLastDateSaved = this._formatLastDateSaved(monthValue, dayOfMonth, year, hour, minute);

    this.setState({
      wishlistLastDateSaved,
      wishlistTotal: this.props.wishlistInfo.total,
      wishlistItems: this.props.wishlistDetailData,
      wishlistItemCount: this.props.wishlistInfo.itemCount,
      wishlistCount: this.props.wishlistUser.wishlistCount,
      ceremonyCollageData: this.props.ceremonyCollageData,
      receptionCollageData: this.props.receptionCollageData
    });
  }

  componentDidMount() {
    $('.loader').hide();

    const getWishlistsRequest = new GoFetch();

    getWishlistsRequest.post('/fetchWishLists/')
      .then((resp) => {
        this.setState({ userWishlists: resp.data.wishLists });
      })
      .catch((err) => console.warn(err));
  }

  _formatLastDateSaved = (month, day, year, hour, minute) => {
    const period = (hour > 12) ? 'PM' : 'AM';
    const formattedHour = (hour > 12) ? (hour - 12) : hour;

    return `${month}/${day}/${year}, ${formattedHour}:${internals.padNum(minute)} ${period}`;
  }

  _confirmDeletedWishlistHandler = () => {
    const wishlistCount = this.state.wishlistCount - 1;
    const userWishlists = this.state.userWishlists.filter((el) => el.id !== this.props.wishlistInfo.id);

    this.setState({
      wishlistItems: {},
      showDeletePanel: false,
      wishlistDeleted: !this.state.wishlistDeleted,
      wishlistCount,
      userWishlists
    });
  }

  _showDeletePanelHandler = (event) => {
    event.preventDefault();

    const showDeletePanel = !this.state.showDeletePanel;

    this.setState({ showDeletePanel });
  }

  _updateWishlistData = (updatedWishlistItems, removedWishlistItemCount, removedWishlistItemTotal, updatedWishlistSavedDate, fetched = false, wishlistRegion = {}) => {
    const updatedItemCount = (fetched) ? removedWishlistItemCount : (this.state.wishlistItemCount - removedWishlistItemCount);
    const updatedItemTotal = (fetched) ? removedWishlistItemTotal : (this.state.wishlistTotal - removedWishlistItemTotal);
    const updatedRegion = (fetched) ? wishlistRegion : this.state.wishlistRegion;

    this.setState({
      wishlistItems: updatedWishlistItems,
      wishlistItemCount: updatedItemCount,
      wishlistTotal: updatedItemTotal,
      wishlistLastDateSaved: updatedWishlistSavedDate,
      wishlistRegion: updatedRegion
    });
  }

  _removeWishlistItemHandler = (eventName, categoryName, subCategoryName, wishListItemId, updatedWishlistSavedDate) => {
    const wishlistDetailsData = $.extend(true, {}, this.state.wishlistItems);
    const stateCollageData = (eventName === 'RECEPTION') ? 'receptionCollageData' : 'ceremonyCollageData';
    const collageData = [...this.state[stateCollageData]];
    const subCategoryArray = wishlistDetailsData[`${eventName}`][`${categoryName}`][`${subCategoryName}`];
    const wishlistItemIndex = subCategoryArray.findIndex( (el) => el.wishListItemId === wishListItemId);
    const wishlistCollageItemIndex = collageData.findIndex( (el) => el.event === eventName && el.subcategoryName === subCategoryName);

    (wishlistCollageItemIndex >= 0) ? collageData[wishlistCollageItemIndex].imagePath = '' : null;

    const { quantity: wishlistItemCount } = subCategoryArray[wishlistItemIndex];
    let { totalPrice: wishlistItemTotal } = subCategoryArray[wishlistItemIndex];

    if (subCategoryArray[wishlistItemIndex].hiddenPrice) {
      wishlistItemTotal = 0;
    }

    if (subCategoryArray.length === 1) {
      delete wishlistDetailsData[`${eventName}`][`${categoryName}`][`${subCategoryName}`];

      if (Object.keys(wishlistDetailsData[`${eventName}`][categoryName]).length === 0) {

        delete wishlistDetailsData[`${eventName}`][`${categoryName}`];
      }
      this._updateWishlistData(wishlistDetailsData, wishlistItemCount, wishlistItemTotal, updatedWishlistSavedDate);

      return 0;
    }
    subCategoryArray.splice(wishlistItemIndex, 1);

    this._updateWishlistData(wishlistDetailsData, wishlistItemCount, wishlistItemTotal, updatedWishlistSavedDate);

    if (wishlistCollageItemIndex > 0) {
      if (eventName === 'RECEPTION') {
        this.setState({ receptionCollageData: collageData });

        return 0;
      }
      this.setState({ ceremonyCollageData: collageData });
    }

    return 0;
  }

  _toggleCollageEventHandler = () => this.setState({ displayCeremonyCollage: !this.state.displayCeremonyCollage });

  _sendEmailHandler = () => {
    const sendEmailRequest = new GoFetch();
    const requestBody = {
      wishListCode: this.props.wishlistInfo.code
    };

    sendEmailRequest.post('/mail-wishlist/', null, requestBody)
      .then((resp) => {
        const emailSent = (resp.status === 'success');

        this.setState({ emailSent });
      })
      .catch((err) => console.error(err));

  }

  _toggleModal = () => {
    this.setState({ isDashboardOpen: !this.state.isDashboardOpen });
    this.forceUpdate();
  }

  _toggleInclusions = () => this.setState({ isInclusionsOpen: !this.state.isInclusionsOpen })

  _renderWishlist = (events) => {
    return (
      <Fragment>
        <div className="wishlist-panel-info-section md-padding container">
          {
            this.state.wishlistDeleted && <p className="deletion-confirmation-copy txt-center">YOUR WISHLIST HAS BEEN DELETED</p>
          }
          {
            this.state.wishlistDeleted && <hr/>
          }
          <div className="row top-xs middle-xxl">
            <div className="xs-12 lg-9">
              <h2 className="wishlist-ttl arial">{this.props.wishlistInfo.name}</h2>
              <span className="wishlist-information arial">
                {`${this.state.wishlistItemCount} Items total, last saved ${this.state.wishlistLastDateSaved}`}
              </span>
            </div>
            <div className="xs-12 lg-3 end-lg">
              <a href="#delete-modal" className="btn-delete-wishlist display-block arial font-bold txt-left js-magnific-popup" onClick={this._showDeletePanelHandler}>
                <i className="icon-close ib"/> DELETE THIS WISHLIST
              </a>
            </div>
          </div>
        </div>
        <CollageContainer
          displayCeremonyCollage={ this.state.displayCeremonyCollage }
          toggleCollageEventHandler={ this._toggleCollageEventHandler }
          ceremonyCollageData={ this.state.ceremonyCollageData }
          receptionCollageData={ this.state.receptionCollageData }
        />
        {
          events.map( (eventName) => <EventList eventName={ eventName } itemsData={ this.state.wishlistItems } key={ eventName } regionId={ this.state.wishlistRegion.id } regionName={ this.state.wishlistRegion.name } wishlistId={ this.props.wishlistInfo.id } wishlistUserId={ this.props.wishlistUser.id } wishlistRemoveItemHandler={ this._removeWishlistItemHandler } wishlistCode={ this.props.wishlistInfo.code } updateWishlistData={ this._updateWishlistData } formatLastDateSaved={ this._formatLastDateSaved } calculateWishlistTotal={ this.props.calculateWishlistTotal } />)
        }
        <div className="container wishlist-container wishlist-summary txt-center">
          <div className="plus-badge white pr">Plus</div>
          <hr className="semi-transparent-grey-dvdr"/>
          <i className="ic ic-logo-sandals" />
          <h3 className="wddng-inclusions-ttl">WEDDING INCLUSIONS</h3>
          <p className="wddng-inclusions-copy">
            <b>Every wedding at Sandals, no matter the size, includes</b> wedding essentials from beautiful wedding décor to a sparkling wine and cold hors d’oeuvres cocktail reception – all accompanied by the personalised attention of your personal wedding planning team.
          </p>
          <button className={`font-bold go-to-link ${this.state.isInclusionsOpen}`} onClick={ this._toggleInclusions } >VIEW WHAT'S INCLUDED IN YOUR WEDDING <i className="icon-arrow-next ib"/></button>
        </div>
        <div className={`container wishlist-container wishlist-inclusions ${this.state.isInclusionsOpen}`}>
          <div className="row around-xxl">
            <ul className="xs-12 lg-6 xxl-5">
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Personal Wedding Planning Team
                </b>
                <p className="wedding-inclusion-item-copy">
                    Our team of wedding professionals will take care of the details for you pre-travel and at the resort until the day you say "I Do."
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Preparation of Marriage Documents
                </b>
                <p className="wedding-inclusion-item-copy">
                    The documents process can be a confusing and complicated one, but with our team of document specialists, the process is made simple and as stress-free as possible.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Picturesque Wedding Location
                </b>
                <p className="wedding-inclusion-item-copy">
                    Our islands feature the most beautiful and natural backdrops for your destination wedding.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Manicure for the Bride
                </b>
                <p className="wedding-inclusion-item-copy">
                    The friendly and attentive staff at our award-winning Red Lane&reg; Spa will pamper you on your special day with a beautiful manicure.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    30-min Foot Massage
                </b>
                <p className="wedding-inclusion-item-copy">
                    Relax before your big day with a 30-minute foot massage from the professionals at Red Lane&reg; Spa.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Musical accompaniment
                </b>
                <p className="wedding-inclusion-item-copy">
                    Select your pre-recorded musical accompaniment for your ceremony.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Bride &amp; Groom Signature Cocktail
                </b>
                <p className="wedding-inclusion-item-copy">
                    Choose a fun and flavourful, specially made cocktail that reflects your personal taste and wedding theme.
                </p>
              </li>
            </ul>
            <ul className="xs-12 lg-6 xxl-5">
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Free Personalised Wedding Website
                </b>
                <p className="wedding-inclusion-item-copy">
                    Customise your own wedding site to share your wedding details with family and friends.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Wedding and Honeymoon Gift Registry
                </b>
                <p className="wedding-inclusion-item-copy">
                    Enjoy the exclusive full service of a free Wedding and Honeymoon registry, where you can add all the bells and whistles you could imagine.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    5" x 7" Wedding Photograph
                </b>
                <p className="wedding-inclusion-item-copy">
                    Take home a complimentary 5"x7" wedding photo.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Romantic Turn Down Service
                </b>
                <p className="wedding-inclusion-item-copy">
                    A special turndown service that includes flower petals on your bed on the first evening of your honeymoon.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Breakfast in Bed
                </b>
                <p className="wedding-inclusion-item-copy">
                    Enjoy a honeymoon mimosa breakfast in bed any night of your choice.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Honeymoon Dinner
                </b>
                <p className="wedding-inclusion-item-copy">
                    A honeymoon dinner for the bride and groom in a speciality restaurant with white-glove service and complimentary sparkling wine.
                </p>
              </li>
              <li className="pr">
                <b className="wedding-inclusion-item-ttl">
                    Cocktail Reception
                </b>
                <p className="wedding-inclusion-item-copy">
                    You and your guests can enjoy a one-hour cocktail reception with sparking wine and cold hors d’oeuvres.
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div className="container wishlist-container wishlist-summary txt-center">
          <hr className="semi-transparent-grey-dvdr"/>
          <span className="events-ttl">RECEPTION &amp; CEREMONY</span>
          <h2 className="estimated-total ttl">Estimated Wedding Total</h2>
          <hr className="wddng-sm-divider"/>
          <span className="estimated-total value">{`$${this.state.wishlistTotal}`}</span>
          <p className="wishlist-disclaimer">
              Please note that the estimated wedding price does not include room and airfare and that certain additional fees may apply.
          </p>
          <div className="wedding-golden-box">
            <span className="intro display-block">ASK A WEDDING SPECIALIST FOR YOUR</span>
            <span className="credit-copy display-block">$500 Wedding Credit</span>
          </div>
          <div className="icon-angle-down"/>
        </div>
        <div className="container wishlist-booking-container">
          <div className="wishlist-code-wrapper txt-center">
            <p className="call-sandals-confirmation white">
              <span>Ready to book this wedding?</span> Please call <b>1-877-SANDALS</b> and provide the code:
            </p>
            <span className="wishlist-code">{ this.props.wishlistInfo.code }</span>
          </div>
          {
            !this.state.emailSent && <button className="btn-wddng-theme arial font-bold display-block" onClick={ this._sendEmailHandler }>{`SEND WISHLIST TO ${this.props.wishlistUser.email}`}</button>
          }
          {
            <span className={`txt-center display-block sent-email-confirmation font-bold ${this.state.emailSent}`}><i className="ic ic-planner display-block"/>{`${this.props.wishlistInfo.name} has been sent to ${this.props.wishlistUser.email.toLowerCase()}`}</span>
          }
          <span className={`txt-center display-block sent-email-error font-bold ${this.state.emailSent}`}>An error ocurred while sending your email, please try again.</span>
        </div>
      </Fragment>
    );
  }

  render() {
    const error = {};

    // Fallback
    if (this.state.showErrorMsg) {
      error.errorReason = 'It appears you are not logged in.';

      if (!this.props.wishlistUser.email) {

        error.errorReason = 'It appears you are not logged in. ';
        error.tryMsg = 'If you already have an account, please try to';
        error.anchorMsg = ' log in.';
        error.url = '#login-modal';
        error.anchorClass = 'js-magnific-popup';

      } else if (!Object.keys(this.props.wishlistInfo).length) {

        error.errorReason = 'We could not retrieve the wishlist information.';
        error.tryMsg = 'Please try to ';
      } else if (!Object.keys(this.props.wishlistDetailData).length && this.props.wishlistUser.email.length) {

        error.errorReason = 'Unable to load information.';
        error.tryMsg = 'Please, select a ';
        error.anchorMsg = 'wishlist';
        error.url = '#login-modal';
        error.anchorClass = 'js-magnific-popup';

      }

    }

    const events = ['CEREMONY', 'RECEPTION'];// Object.keys(this.props.wishlistDetailData);
    const viewWishlistMsg = `VIEW A WISHLIST ${(this.state.wishlistCount) ? `(${this.state.wishlistCount})` : ''}`;

    return (
      <section className={`wishlist-panel ${this.state.wishlistDeleted}`}>
        <div className="wishlist-panel-info-section container">
          <div className="row">
            <div className="xs-12 lg-4 xxl-3">
              <a href="#login-modal" className="btn-default dark-theme view-wishlist txt-center js-magnific-popup">
                {`${viewWishlistMsg}`}
                <i className="ic ic-button-arrow-next ib" />
              </a>
            </div>
            <div className="xs-12 lg-8 xxl-offset-1 end-lg">
              <WeddingCircleInPre />
            </div>
          </div>
          <hr/>
        </div>
        {
          this.state.showErrorMsg && <ErrorMsg { ...error } />
        }
        {
          !this.state.showErrorMsg && this._renderWishlist(events)
        }
        <Modal id="login-modal">
          <div className="container-fluid collage-login-panel">
            <LoginPanel
              countries={ this.props.countries }
              hasCreateWishlist={ false }
              modalUpdateHandler={ this._toggleModal }
              fromWishlistCollage
              userWishlists={ this.state.userWishlists }
              shouldLogIn={ !this.props.wishlistUser.hasOwnProperty('id') }
            />
          </div>
        </Modal>
        <Modal id="delete-modal">
          <div className="container-fluid">
            <DeletePanel
              wishlistCode={ this.props.wishlistInfo.code }
              wishlistName={ this.props.wishlistInfo.name }
              showPanel={ this.state.showDeletePanel }
              showDeletePanelHandler={ this._showDeletePanelHandler }
              confirmDeletedWishlistHandler = { this._confirmDeletedWishlistHandler } />
          </div>
        </Modal>
      </section>
    );
  }
}
